/* eslint-disable require-jsdoc */
export function selectVenues(state) {
    return state.venues.venues;
}
